import { PAGINATION } from '@coworkrz/core/constants';
import { OrderType } from '@coworkrz/core/types';
import { CastHelper } from './cast.helper';
import { Expose, Transform } from 'class-transformer';
import {
  IsOptional,
  IsPositive,
  IsString,
  IsUUID,
  Max,
  Min,
} from 'class-validator';

import 'reflect-metadata';

export class BaseDto {
  @Expose()
  id: string;

  @Expose()
  createdAt?: Date | string;

  @Expose()
  updatedAt?: Date | string;

  @Expose()
  deletedAt?: Date | string;
}

export class BaseFiltersDto {
  @IsOptional()
  @IsUUID()
  id?: string;

  @IsOptional()
  @IsString()
  query?: string | null;

  @Transform(({ value }) =>
    CastHelper.toNumber(value, {
      default: PAGINATION.DEFAULT_PAGE,
    })
  )
  @IsOptional()
  @IsPositive()
  @Min(PAGINATION.DEFAULT_PAGE)
  page?: number = PAGINATION.DEFAULT_PAGE;

  @Transform(({ value }) =>
    CastHelper.toNumber(value, {
      default: PAGINATION.DEFAULT_LIMIT,
    })
  )
  @IsOptional()
  @IsPositive()
  @Min(1)
  @Max(PAGINATION.MAX_LIMIT + 1)
  limit?: number;

  @Transform(({ value }) => CastHelper.toOrder(value))
  @IsOptional()
  order?: OrderType;

  @Transform(({ value }) => CastHelper.trim(value))
  @IsOptional()
  orderField?: string;

  @Transform(({ value }) => CastHelper.toBoolean(value))
  @IsOptional()
  withDeleted?: boolean;
}
